// extracted by mini-css-extract-plugin
export default {"tasks":"TasksList_tasks__-t3N3","empty":"TasksList_empty__pc+Gj","tasksGrid":"TasksList_tasksGrid__MCm4k"};